export default "<mat-card class=\"card\">\r\n    <ng-content></ng-content>\r\n</mat-card>\r\n"